/* import __COLOCATED_TEMPLATE__ from './accept-terms-modal.hbs'; */
import EmberObject, { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import LSGModalBase from "../lsg/lsg-modal-dialog-base";
import { closeModal } from 'sh-www/utils/modal-controls';

export default LSGModalBase.extend({
  /**
   * Register services
   */

  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * @param {Application}
     */
    application: null,

    /**
     * @param {Legal}
     */
    legalToShow: null,

    /**
     * Callback after user has confirmed the legal.
     *
     * @param {Function}
     */
    onLegalAgreed: function(legalAgreed) {}
  },

  /**
   * @inheritDoc
   */
  stateDefaults: {
    /**
     * @type {Boolean}      True if user has selected agree to terms
     */
    areTermsAgreed: false,

    /**
     * @type {Boolean}      True when the user has clicked on the disabled button and we need
     *                      to show the checkbox text more pronounced
     */
    isCheckboxTextHighlighted: false
  },

  /**
   * @type {Boolean} Whether this is a Select project.
   */
  _isSelect: alias('model.application.select'),

  /**
   * @type {Ember.Object} The project price data.
   */
  _projectPrice: computed('model.application.price', function () {
    return this.get('model.application.price');
  }),

  /**
   * @type {Ember.Object} The service fee data.
   */
  _serviceFee: computed(
    'model.application.feeStructure.sellerBaseFee',
    'model.application.price',
    function () {
      const percentage = this.get('model.application.feeStructure.sellerBaseFee');
      const percentageFormatted = `${percentage * 100}%`;
      const amount = -(Math.round(this.get('model.application.price') * percentage * 100) / 100);

      return EmberObject.create({
        percentage,
        percentageFormatted,
        amount,
      });
    },
  ),

  /**
   * @type {Ember.Object} The select fee data.
   */
  _selectFee: computed(
    'model.application.feeStructure.sellerSelectFee',
    'model.application.price',
    function () {
      const percentage = this.get('model.application.feeStructure.sellerSelectFee');
      const percentageFormatted = `${percentage * 100}%`;
      const amount = -(Math.round(this.get('model.application.price') * percentage * 100) / 100);

      return EmberObject.create({
        percentage,
        percentageFormatted,
        amount,
      });
    },
  ),

  /**
   * @type {Ember.Object} The payout data for the seller.
   */
  _sellerPayout: computed(
    '_projectPrice',
    '_serviceFee.amount',
    '_isSelect',
    '_selectFee.amount',
    function () {
      const isSelect = this.get('_isSelect');
      const serviceFee = this.get('_serviceFee.amount');
      const selectFee = this.get('_selectFee.amount');
      let amount = this.get('_projectPrice');

      if (serviceFee) {
        amount += serviceFee;
      }

      if (isSelect && selectFee) {
        amount += selectFee;
      }

      return amount;
    },
  ),

  actions: {
    /**
     * This is a wrapper around the 'Approve' button since it won't fire events when disabled.
     */
    onApproveTermsButtonWrapperClicked: function() {
      if (this.isDestroying) return;
      if (!this.get('state.areTermsAgreed')) {
        this.set('state.isCheckboxTextHighlighted', true);
      }
    },

    /**
     * When user clicks the enabled approve terms button on the modal
     */
    onApproveTermsClicked: function() {
      this.get('model.onLegalAgreed')(this.get('model.legalToShow'));
      closeModal(this);
    },

    /**
     * When user clicks checkbox
     */
    onCheckboxToggled() {
      this.set('state.areTermsAgreed', !this.state.areTermsAgreed);
    },

    closeModal() {
      closeModal(this);
    }
  }
});
